import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";
import { FaApple } from "react-icons/fa";
import { useLanguage } from "../../context/LanguageContext";

function ProjectCards(props) {
  const { t } = useLanguage();
  const projectInitials = props.title
    .split(" ")
    .slice(0, 2)
    .map((word) => word[0])
    .join("");

  return (
    <Card className="project-card-view">
      {props.imgPath ? (
        <Card.Img variant="top" src={props.imgPath} alt={`${props.title} preview`} />
      ) : (
        <div className={`project-cover project-cover-${props.coverTone || "navy"}`}>
          <span>{props.sourceLabel || t("projects.eyebrow")}</span>
          <strong>{projectInitials}</strong>
          <small>{props.tech}</small>
        </div>
      )}
      <Card.Body>
        <span className="project-eyebrow">
          {props.sourceLabel || t("projects.eyebrow")}
        </span>
        <Card.Title>{props.title}</Card.Title>
        {props.tech && <div className="project-tech">{props.tech}</div>}
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>
        <div className="project-links">
          {props.ghLink && (
            <Button variant="primary" href={props.ghLink} target="_blank" rel="noreferrer">
              <BsGithub /> &nbsp;
              {props.ghLabel || (props.isBlog ? "Blog" : t("projects.source"))}
            </Button>
          )}
          {props.secondaryGhLink && (
            <Button
              variant="primary"
              href={props.secondaryGhLink}
              target="_blank"
              rel="noreferrer"
            >
              <BsGithub /> &nbsp;
              {props.secondaryGhLabel || t("projects.source")}
            </Button>
          )}
        {"\n"}
        {"\n"}

        {/* If the component contains Demo link and if it's not a Blog then, it will render the below component  */}

        {!props.isBlog && props.demoLink && (
          <Button
            variant="primary"
            href={props.demoLink}
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: "10px" }}
          >
            <CgWebsite /> &nbsp;
            {props.demoLabel || t("projects.demo")}
          </Button>
        )}
        {!props.isBlog && props.iosLink && (
          <Button
            variant="primary"
            href={props.iosLink}
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: "10px" }}
          >
            <FaApple /> &nbsp;
            iOS
          </Button>
        )}
        </div>
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
